/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Membership_EndedInputs */

const en_us2_group_membership_ended = /** @type {(inputs: Group_Membership_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are no longer part of this group.`)
};

const pt_br2_group_membership_ended = /** @type {(inputs: Group_Membership_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não faz mais parte desta turma.`)
};

const pt_pt2_group_membership_ended = /** @type {(inputs: Group_Membership_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não faz mais parte desta turma.`)
};

/** @type {(inputs: Group_Membership_EndedInputs) => LocalizedString} */
const es_419_group_membership_ended = en_us2_group_membership_ended;

/** @type {(inputs: Group_Membership_EndedInputs) => LocalizedString} */
const fr_fr2_group_membership_ended = en_us2_group_membership_ended;

/** @type {(inputs: Group_Membership_EndedInputs) => LocalizedString} */
const de_de2_group_membership_ended = en_us2_group_membership_ended;

/** @type {(inputs: Group_Membership_EndedInputs) => LocalizedString} */
const it_it2_group_membership_ended = en_us2_group_membership_ended;

/**
* | output |
* | --- |
* | "You are no longer part of this group." |
*
* @param {Group_Membership_EndedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_membership_ended = /** @type {((inputs?: Group_Membership_EndedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Membership_EndedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_membership_ended(inputs)
	if (locale === "es-419") return es_419_group_membership_ended(inputs)
	if (locale === "pt-PT") return pt_pt2_group_membership_ended(inputs)
	if (locale === "fr-FR") return fr_fr2_group_membership_ended(inputs)
	if (locale === "de-DE") return de_de2_group_membership_ended(inputs)
	if (locale === "it-IT") return it_it2_group_membership_ended(inputs)
	return en_us2_group_membership_ended(inputs)
});
export { group_membership_ended as "group.membership_ended" }